import { AssetBoundsDisplay } from './AssetBoundsDisplay';
import { AssetAnchorDisplay } from './AssetAnchorDisplay';
import { AssetMaxBoundsDisplay } from './AssetMaxBoundsDisplay';
import { WatermarkBoundsDisplay } from './WatermarkBoundsDisplay';

export { AssetBoundsDisplay, AssetAnchorDisplay, AssetMaxBoundsDisplay, WatermarkBoundsDisplay };

/**
 * @internal
 */
export function _isHelperDisplay(
    object: unknown,
): object is
    | AssetBoundsDisplay
    | AssetAnchorDisplay
    | AssetMaxBoundsDisplay
    | WatermarkBoundsDisplay {
    return (
        object instanceof AssetBoundsDisplay ||
        object instanceof AssetAnchorDisplay ||
        object instanceof AssetMaxBoundsDisplay ||
        object instanceof WatermarkBoundsDisplay
    );
}
